<template>
  <svg
    viewBox="0 0 96 74"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
  >
    <g>
      <path
        d="M12.514 72.5c6.076 0 11-4.925 11-11.002 0-6.073-4.924-10.998-11-10.998s-11 4.925-11 10.998c0 6.077 4.924 11.002 11 11.002ZM48 72.5c6.076 0 11-4.925 11-11.002C59 55.425 54.076 50.5 48 50.5s-11 4.925-11 10.998C37 67.575 41.924 72.5 48 72.5ZM83.5 72.45c6.076 0 11-4.925 11-11.002 0-6.073-4.924-10.998-11-10.998s-11 4.925-11 10.998c0 6.077 4.924 11.002 11 11.002Z"
        stroke-width="3"
      />
      <path
        d="M48 23.439c6.076 0 11-4.925 11-11.002 0-6.073-4.924-10.998-11-10.998S37 6.364 37 12.437c0 6.077 4.924 11.002 11 11.002Z"
        stroke-width="3"
      />
      <path
        d="M12.479 51.086V38.602h71.042v11.059M48 24.659v26.425"
        stroke-width="3"
      />
    </g>
  </svg>
</template>
